import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { useState, useEffect, useRef } from "react";
import SearchCriteria from "./index/SearchCriteria";
import RecentList from "./index/RecentList";
import IndexingForm from "./index/IndexingForm";
import services from "../services/indexService";
import { taskPaneInitailValue, useTaskPane } from "../provider/TaskPaneProvider";
import useToast from "../hooks/useToast";
import { jwtDecode } from "jwt-decode";
import {SetAxiosDefauls} from "../services/authInterceptor";
import Loader from "./index/loader";
import { appInsights, track, trackEvent, trackError, isVerboseTelemetry } from '../../telemetry/telemetryService';

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const MainContent = (props) => {
  SetAxiosDefauls();
  const {
    setProfileDetails,
    setLocationData,
    taskPaneState,
    setTaskPaneState,
    profileDetails,
    setSelectedGridItem,
    setPoliciesDetailsForInsured,
    selectedItemDetailFromGrid,
    setCheckList,
    getLocationSpecificInfo,
    loading,
    setLoading,
    checkList,
    selectedGridItem,
    setDocumentType,
    setDocumentClass
  } = useTaskPane();
  const { Toaster, notify, dismissAllToasts } = useToast();
  const [username, setUsername] = useState(null);
  const attemptedAuthName = useRef(null);
  const accessToken = localStorage.getItem('access-token');
  const authToken = localStorage.getItem('auth-token');
  // Set when running in a plain browser (no Office host) AND direct auth is forbidden (prod):
  // show an "open in Word" message instead of ever prompting for an email.
  const [directBlocked, setDirectBlocked] = useState(false);
  // Direct-auth (browser) only: when no email is known yet, render an in-app entry form.
  // office.js disables window.prompt ("Function window.prompt is not supported"), so a blocking
  // prompt crashes the task pane -- use a controlled input instead.
  const [emailNeeded, setEmailNeeded] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [authStatus, setAuthStatus] = useState("idle");
  const [profileStatus, setProfileStatus] = useState("idle");
  const [locationStatus, setLocationStatus] = useState("idle");
  const resetLocationState = () => {
    setLocationData([]);
    setTaskPaneState((prev) => ({ ...prev, comLocId: "", compLocId: "", compId: "" }));
  };
  const getData = async () => {
    try {
        resetLocationState();
        setTaskPaneState((prev) => ({ ...prev, userId: "" }));
        notify("progress");
        setProfileStatus("loading");
        if (username != null) {
            console.log("Username retrieved:");
        }
        const result = await services.getUserProfileInfo(username);
        notify("success", "Profile data fetch successful!");
        track("bootstrap.getData", { rowCount: result?.length ?? 0, userId: result?.[0]?.userID ?? null });
        setProfileStatus("success");
        setProfileDetails(result);
        if (!result?.length) {
          setLocationData([]);
          sessionStorage.removeItem("userId");
          setLocationStatus("empty");
          return;
        }
        sessionStorage.setItem('userId', result[0]?.userID);
        setTaskPaneState((prev) => ({ ...prev, userId: result[0]?.userID, profileUserGroupId: result[0]?.primaryUserGroupID, userGroupId: result[0]?.primaryUserGroupID, userGroup: result[0]?.userID }));
        getLocationData(result);
    } catch (e) {
        notify("error", "Failed to fetch profile data");
        setProfileStatus("error");
        console.log(e);
        trackError(e, { seam: "bootstrap.getData" });
    }
    };
    const getAuthToken = async (name) => {
    attemptedAuthName.current = name;
    try {
      setAuthStatus("loading");
      setProfileStatus("idle");
      setLocationStatus("idle");
      setLocationData([]);
      setTaskPaneState((prev) => ({ ...prev, userId: "", comLocId: "", compLocId: "", compId: "" }));
      localStorage.removeItem("auth-token");
      // notify("progress");
      if (username != null) {
        console.log("Username retrieved:");
      }
      const result = await services.getAuthToken(name);
      console.log('result', result);
      if (typeof result?.access_token !== "string" || !result.access_token.trim()) throw new Error("Missing auth token");
      setAuthStatus("success");
      localStorage.setItem("auth-token", result.access_token)
      setUsername(name);
      // Email is dev data -> only attach the identity in non-prod; counts/flags everywhere.
      trackEvent("auth.getAuthToken.success", { hasToken: !!result.access_token, ...(isVerboseTelemetry ? { name } : {}) });
    } catch (e) {
      setAuthStatus("error");
      // notify("error", "Failed to fetch profile data");
      console.log(e);
      trackError(e, { seam: "auth.getAuthToken" });
    }
  };

  const getLocationData = async (profileData) => {
    try {
        resetLocationState();
        notify("progress");
        if (username != null) {
            console.log("Username retrieved:");
        }
        track("bootstrap.getLocationData.called", {});
        setLocationStatus("loading");
        const result = await services.bindLocation(username);
        notify("success", "Location data fetch successful!");
        // KEY diagnostic seam: did locations load, and how many rows. Empty here -> empty
        // Criteria dropdown -> SearchByCriteria 400. This was invisible to AI before.
        trackEvent("bootstrap.getLocationData.result", { rowCount: result?.length ?? 0 });
        setLocationData(result);
        setLocationStatus(result?.length ? "success" : "empty");
        if(result?.length ===1) {
           setPoliciesDetailsForInsured([]);
          setSelectedGridItem([]);
          setCheckList([]);
          const value = result[0]?.compLocID;
          const compId = profileData.filter((pd) => pd.compLocID == value)[0]?.companyID;
          setTaskPaneState((prev) => ({ ...prev, comLocId: value, compLocId: value, compId, checklistItem: "" }));
          if(value && compId)
            await getLocationSpecificInfo(value, compId, profileData[0].userID);
          }
    } catch (e) {
        notify("error", "Failed to fetch location data");
        setLocationStatus("error");
        console.log(e);
        trackError(e, { seam: "bootstrap.getLocationData" });
    }
  };

    const retryBootstrap = (stage) => {
      if (stage === "auth") return getAuthToken(attemptedAuthName.current || username || localStorage.getItem("dev-user-email"));
      if (stage === "profile") return getData();
      if (stage === "location") return getLocationData(profileDetails);
      return undefined;
    };

    useEffect(() => {
        // SSO seam: was an access-token (Office SSO) present when the taskpane mounted?
        trackEvent("sso.accessToken", { present: !!accessToken });
        if (accessToken) {
            setAuthStatus("loading");
            try {
                const decoded = jwtDecode(accessToken);
                const preferredName =
                    decoded.preferred_username || decoded?.unique_name || decoded.userPrincipalName || decoded.name || null;
                if (preferredName != null) {
                  console.log("Decoded username from token");
                  getAuthToken(preferredName);
                } else {
                  setAuthStatus("error");
                }
            } catch (err) {
                setAuthStatus("error");
                console.error("Failed to decode token:", err);
                trackError(err, { seam: "sso.decodeAccessToken" });
            }
        }
    }, [accessToken]);

    // Auth-path selection by RUNTIME Office-host detection. Office.onReady resolves with
    // info.host = an Office.HostType (Outlook/Excel/Word) when hosted, and null/undefined when
    // the page is loaded in a plain browser (office.js is present but no host attaches).
    //   - host present  -> SSO path (the [accessToken] effect above); do nothing here.
    //   - host absent + direct PERMITTED (local or non-prod deploy, DIRECT_AUTH_ALLOWED) ->
    //       direct dev-auth: mint the app token directly and scope data by the dev's OWN
    //       identity (no SSO/consent). Resolve the email without a hardcoded person: build-time
    //       override (DEV_USER_EMAIL / public.js shared account), else a value this browser
    //       entered before, else prompt once and remember it.
    //   - host absent + direct FORBIDDEN (prod) -> show "open in Word"; NEVER prompt.
    // DIRECT_AUTH_ALLOWED is a build-time literal, so prod DCEs the direct branch entirely --
    // it cannot be re-enabled by tampering with a client value.
    useEffect(() => {
        Office.onReady((info) => {
            const host = info && info.host;
            // Diagnostic seam: which auth path the runtime chose (hosted Office host name vs browser).
            trackEvent("host.detection", { host: host ? String(host) : "browser", directAllowed: !!process.env.DIRECT_AUTH_ALLOWED });
            if (host) return; // hosted in Office -> SSO path
            if (!process.env.DIRECT_AUTH_ALLOWED) {
                setDirectBlocked(true);
                return;
            }
            const email = process.env.DEV_USER_EMAIL || localStorage.getItem("dev-user-email");
            if (email) {
                getAuthToken(email);
            } else {
                // No baked/remembered email -> ask via an in-app form (window.prompt is blocked
                // by office.js). The form's submit handler stores + calls getAuthToken.
                setEmailNeeded(true);
            }
        }).catch((err) => {
          setAuthStatus("error");
          trackError(err, { seam: "sso.officeOnReady" });
        });
    }, []);

    const submitDevEmail = (e) => {
        if (e) e.preventDefault();
        const email = (emailInput || "").trim();
        if (!email) return;
        localStorage.setItem("dev-user-email", email);
        setEmailNeeded(false);
        getAuthToken(email);
    };

  useEffect(() => {
    if (username && !!authToken) {
      getData();
    }
  }, [username, authToken]);

    const criteriaChange = (criteria) => criteria === "Insured" || criteria === "Policy #"|| criteria  === "Submission #"
        ? "Type Insured/Policy"
        : criteria === "Producer #" || criteria === "Producer Name"
          ? "Type Producer"
          : "Type claim"

  const updateState = async (key, value) => {
    dismissAllToasts();
    switch (key) {
     case "comLocId":
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
        setCheckList([]);
        setDocumentType([]);
        setDocumentClass([]);
        const compId = profileDetails.filter((pd) => pd.compLocID == value)[0]?.companyID;
        if(value && compId) {
          setTaskPaneState((prev) => ({ ...prev, ...taskPaneInitailValue, [key]: value, compLocId: value, compId, searchText: "", userGroupId: prev?.profileUserGroupId, userGroup: prev?.userId }));
          await getLocationSpecificInfo(value, compId);
        } else {
          setTaskPaneState((prev) => ({ 
            ...prev, 
            ...taskPaneInitailValue, 
            [key]: value, 
            compLocId: value, 
            compId, 
            searchText: "", 
            userGroupId: prev?.profileUserGroupId, 
            userGroup: prev?.userId,
            insuredForRecentPoliciesResults: [],
            criteriaItems: [],
            criteria: "",
            insuredId: "",
          }));
        }
        break;
      case "criteria":
        let searchText = taskPaneState?.searchText;
        let checklistItem = taskPaneState?.checklistItem;
        if (criteriaChange(taskPaneState.criteria) !== criteriaChange(value)) {
          setPoliciesDetailsForInsured([]);
          setSelectedGridItem([]);
          searchText = "";
          checklistItem = "";
          if(criteriaChange(value) === "Type Insured/Policy" && taskPaneState.comLocId) {
            getLocationSpecificInfo(taskPaneState.compLocId, taskPaneState.compId, taskPaneState?.userId, value);
          }
        }
          setTaskPaneState((prev) => ({ ...prev, [key]: value, searchText, checklistItem}));
        break;
      case "insuredId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "searchText":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "userGroupId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value, userGroup: prev?.userId, taskQueue: "", taskType: "" }));
        break;
      case "docDescription":
      case "taskSubject":
        if(value?.length <= 60) {
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
      } else if(!!value && value?.length > 60) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 60) }));
        }
        break;
      case "docNotes":
        if(value?.length <= 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        } else if(!!value && value?.length > 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 255) }));
        }
        break;
      case "checklistItem":
        const desctext = !!value? checkList.find(x => x.policyChecklistId == value)?.description || "" : "";
        const descTextTrim = (!!desctext && desctext?.length > 60) ? desctext.substring(0, 60) : desctext || "";
        setTaskPaneState((prev) => ({ 
          ...prev, 
          [key]: value, 
          docDescription: prev?.useChecklistItem? descTextTrim : prev?.docDescription || "",
          taskSubject: (prev?.sameAsDocDesc && prev?.useChecklistItem)? descTextTrim : prev?.taskSubject || ""
        }));
        break;
      case "useFileName":
        const fileName = localStorage.getItem("fileName");
        const fileNameText = value? (!!fileName && fileName?.length > 60) ? fileName.substring(0, 60) : fileName || "" : ""
        setTaskPaneState((prev) => ({ ...prev, 
          [key]: value, 
          useChecklistItem: value? false: prev?.useChecklistItem,
          sameAsDocDesc: (!value && !prev?.useChecklistItem)? false : prev?.sameAsDocDesc,
          taskSubject: prev?.sameAsDocDesc? fileNameText : prev?.taskSubject,
          docDescription: fileNameText
        }));
        break;
      case "useChecklistItem":
        let checkItemText = "";
        if(checkList?.length && !!taskPaneState?.checklistItem) {
          const checkItemData = checkList.find(x => x.policyChecklistId == taskPaneState?.checklistItem)
          checkItemText = checkItemData?.description || "";
        }
        const descText = value? (!!checkItemText && checkItemText?.length > 60) ? checkItemText.substring(0, 60) : checkItemText || "" : "";
          setTaskPaneState((prev) => ({ ...prev, 
            [key]: value, 
            useFileName: value? false: prev?.useFileName,
            sameAsDocDesc: (!value && !prev?.useFileName)? false : prev?.sameAsDocDesc,
            taskSubject: prev?.sameAsDocDesc? descText : prev?.taskSubject,
            docDescription: descText
          }));
        break;
      default:
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
    }
  };

  const handleIndex = () => {
      // check date validation
      dismissAllToasts();
      const referenceDate = new Date("1900-01-01");
      if (taskPaneState?.receivedDate) {
        const dateToCheck = new Date(taskPaneState?.receivedDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Received Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskStartDate) {
        const dateToCheck = new Date(taskPaneState?.taskStartDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Start Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskDueDate) {
        const dateToCheck = new Date(taskPaneState?.taskDueDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Due Date must be on or after 01/01/1900");
          return
        }
      }

        setLoading(true);
    callParentIndex();
  }

  const callParentIndex = async () => {
    appInsights.trackEvent({ name: 'ButtonClicked', properties: { buttonName: 'SaveIndex', userID: taskPaneState?.userId } });
   try {
     let SubmissionDetails = {
            SubmissionID: null,
            PolicyID: selectedItemDetailFromGrid?.policyID,
            DocType: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
            DocumentClassID: +taskPaneState.documentClass,
            WorkflowUserID: +taskPaneState?.userGroup,
            Destination: "",
            DestName: "",
            PipsProducer: {
              ProducerID: selectedItemDetailFromGrid?.ProducerID,
              IndexingUserID: taskPaneState?.userId
            },
            FileURL: null,
            Container: null,
            ExtractAttachments: false,
            OriginatingOfficeID: "1",

            Sender: null,
            Recipient: null,
            CC: "",
            EmailHTML: null,
            FileContents: ""
          }
           const bodyData = {
                    subject: taskPaneState.taskSubject,
                    DocTypeId: taskPaneState?.documentType,
                    emailTime: "",
                    docTypeUsage: taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Policy #"|| taskPaneState?.criteria  === "Submission #"? 1: 4,
                    description: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
                    dueDate: taskPaneState?.taskDueDate? new Date(taskPaneState?.taskDueDate): null,
                    pendDate: taskPaneState?.taskStartDate? new Date(taskPaneState?.taskStartDate): null,
                    modUserID: taskPaneState?.userId,
                    policyID: selectedItemDetailFromGrid?.policyID,
                    claimIncidentMasterID: 0,
                    providerID: 0,
                    producerID: 0,
                    destination: "",
                    destName: "",
                    workFlowUserID: +taskPaneState?.userGroup,
                    documentClassID: +taskPaneState?.documentClass,
                    compLocID: +taskPaneState?.comLocId,
                    indexNote: taskPaneState?.docNotes,
                    documentNote: taskPaneState?.docNotes,
                    note: taskPaneState?.taskNote,
                    task: taskPaneState?.taskChecked,
                    receivedDate: taskPaneState?.receivedDate? new Date(taskPaneState?.receivedDate) : null,
                    priorityID: +taskPaneState?.taskPriority,
                    taskTypeID: +taskPaneState?.taskType,
                    userGroupID: +taskPaneState?.userGroupId,
                    vendorID: 0,
                    campaignID: 0,
                    transSummaryID: 0,
                    docType: taskPaneState?.documentType,
                    policyChecklistID: +taskPaneState?.checklistItem,
                    chkTask: !!taskPaneState?.taskChecked,
                    chkUseFileName: !!taskPaneState?.useFileName,
                    chkQuoteSentToProducer: !!taskPaneState?.chkQuoteSentToProducer,
                    intFileID: 0,
                    userID: taskPaneState?.userId,
                    queueID: +taskPaneState?.taskQueue,
                    fileID: 0,
                    workFlowUser: "",
                    workFlowDestination: "",
                    submissionDetails: {
                      ...SubmissionDetails
                    }
                  };
          Office.context.ui.messageParent(JSON.stringify({ sendIndexApi: true, ...bodyData }));
          appInsights.trackDependencyData({
            target: process.env.BASE_URL,
            name: "Word_Saveindex_Payload",
            properties: { ...bodyData },
          });
   } catch (e) {
    setLoading(false);
    notify("error", "Failed to send indexing request");
    console.log(e);
   }
  }

  useEffect(() => {
  Office.onReady().then(() => {
                console.log("Dialog sending 'ready' to parent...");
                // Guard: messageParent only works in a dialog (displayDialogAsync) and throws
                // ("Cannot read properties of undefined (reading 'messageParent')") in a plain
                // browser where Office.context is undefined. Optional-chain so the dialog
                // handshake still fires when hosted, but never crashes the browser/taskpane.
                Office.context?.ui?.messageParent?.("ready");

                Office.context?.ui?.addHandlerAsync?.(
                    Office.EventType.DialogParentMessageReceived,
                    (arg) => {
                        if (!arg) return;
                        console.log("Response received in dialog:", arg.message);
                        if (arg.message === "Failed") {
                          setLoading(false);
                          notify("error", "Failed to index");
                          
                          appInsights.trackDependencyData({
                            target: process.env.BASE_URL,
                            name: "Word_Saveindex_Payload",
                            dependencyTypeName: "HTTPS",
                            success: false,
                            responseCode: 500,
                            properties: {
                              error: "Failed to index"
                            }
                          });
                          return;
                        } else if (arg.message === "ok") {
                          setLoading(false);
                          notify("success", "Indexing successful!");
                          handleModel();
                          return;
                        }
                        
                      let mes;
                      try { mes = JSON.parse(arg?.message); } catch (_e) { return; }
                      if (!mes || typeof mes !== "object") return;
                      if (!!mes?.Failed && mes?.errorText) {
                        notify("error", mes?.errorText);
                        setLoading(false);

                        appInsights.trackDependencyData({
                          target: process.env.BASE_URL,
                          name: "Word_Saveindex_Payload",
                          dependencyTypeName: "HTTPS",
                          success: false,
                          responseCode: (mes?.errorText == "File is larger than allowed size") ? 400 : 500,
                          properties: {
                            error: mes?.errorText
                          }
                        });
                      }
                    }
                );
            });
  }, []);

    const handleModel = () => {
    Office.context.ui.messageParent(JSON.stringify({ close: true }));
  }

  const styles = useStyles();

  const clearToaster = () => {
    dismissAllToasts();
    notify("progress");
  }

  useEffect(() => {
    dismissAllToasts();
  }, [selectedGridItem])

  Office.onReady(() => {
    appInsights.trackPageView({ name: "Taskpane Loaded" });
  });

  if (directBlocked) {
    return (
      <div className={styles.root}>
        <div className="page-bg">
          <div className="page-layout relative w-full mx-auto text-black z-10">
            <div className="main-container p-4 mt-1 text-center">
              <h2 className="h2-text text-base font-semibold text-black-700 mb-2">
                Please open this add-in inside Word
              </h2>
              <p className="text-sm text-gray-600">
                Sign-in to PIPS requires the Office host. Open the add-in from Word to continue.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (emailNeeded) {
    return (
      <div className={styles.root}>
        <div className="page-bg">
          <div className="page-layout relative w-full mx-auto text-black z-10">
            <form className="main-container p-4 mt-1" onSubmit={submitDevEmail}>
              <h2 className="h2-text text-base font-semibold text-black-700 mb-2">Dev mode sign-in</h2>
              <p className="text-sm text-gray-600 mb-2">Enter your email to load PIPS data:</p>
              <input
                type="email"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                placeholder="you@bbins.com"
                className="input-layout rounded py-1 px-2 text-sm text-gray-700 w-full mb-2"
              />
              <button type="submit" className="btn-com" disabled={!emailInput.trim()}>
                Continue
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
      <div className={styles.root}>
               {loading && <Loader />}
          <div className="page-bg">
              <div className="page-layout relative w-full mx-auto text-black z-10">
                 {/* <nav className="header-bg text-white px-4 py-1 shadow-md flex justify-between items-center fixed top-0 left-0 w-full  z-10" >
            <div className="w-full mx-auto px-0 flex justify-between items-center">
              <h1 className="text-sm font-semibold">PIPS</h1>
              <span className="text-sm">V4.0</span>
            </div>
          </nav> */}
          {Toaster}
          <div className="main-container p-1 mt-1">
                  <div className="card-layout p-2 shadow-md">
         
          <SearchCriteria
            updateState={updateState}
            clearToaster={clearToaster}
            locationStatus={locationStatus}
            authStatus={authStatus}
            profileStatus={profileStatus}
            onRetryBootstrap={retryBootstrap}
          />
          <RecentList
            updateState={updateState}
          />
          </div>
          <IndexingForm updateState={updateState} handleIndex={handleIndex} handleModel={handleModel} />
        </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
